import { render } from "./WorkspaceMenuForm.vue?vue&type=template&id=593e6310"
import script from "./WorkspaceMenuForm.vue?vue&type=script&lang=js"
export * from "./WorkspaceMenuForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/WorkspaceMenuForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "593e6310"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('593e6310', __exports__)) {
    api.reload('593e6310', __exports__)
  }
  
  module.hot.accept("./WorkspaceMenuForm.vue?vue&type=template&id=593e6310", () => {
    api.rerender('593e6310', render)
  })

}


export default __exports__